"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateReservePriceDto = instanceOfUpdateReservePriceDto;
exports.UpdateReservePriceDtoFromJSON = UpdateReservePriceDtoFromJSON;
exports.UpdateReservePriceDtoFromJSONTyped = UpdateReservePriceDtoFromJSONTyped;
exports.UpdateReservePriceDtoToJSON = UpdateReservePriceDtoToJSON;
exports.UpdateReservePriceDtoToJSONTyped = UpdateReservePriceDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateReservePriceDto interface.
 */
function instanceOfUpdateReservePriceDto(value) {
    if (!('reservePrice' in value) || value['reservePrice'] === undefined)
        return false;
    return true;
}
function UpdateReservePriceDtoFromJSON(json) {
    return UpdateReservePriceDtoFromJSONTyped(json, false);
}
function UpdateReservePriceDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reservePrice': json['reservePrice'],
    };
}
function UpdateReservePriceDtoToJSON(json) {
    return UpdateReservePriceDtoToJSONTyped(json, false);
}
function UpdateReservePriceDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'reservePrice': value['reservePrice'],
    };
}
